import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType  } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {modEdit_template} from "../components/templates/modEdit_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;
declare var CKEDITOR: any;
CKEDITOR.timestamp = '1.2.0';

let descriptionEditor;
let instructionsEditor;

export class mod_edit extends vnModule_knockoutJS{

    protected editForm : modEdit_template
    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdlCaller: string;
    protected _isLeavePageWarningNeeded: boolean = true;

    buildContent(): Array<Element> {

        this.editForm = new modEdit_template('modEditTemplate', this.viewModel, this)
        return [this.editForm.build()]
    }

    protected getModuleName(): string {

        return "mod_edit";
    }

    public fillPage() {

        this.getReferences();
        this.initializeCkEditors()
        this.intilizeFileUploaders();
    }

    protected getReferences() {

        // LOADING : starts
        this.loadingIn(this.editForm.builtTemplate);

        let usrReq_url: string = '/api/mod/references';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdls['getReferences'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls['getReferences'].onReadyStateFunction = this.onReferencesRequestReturn;
        this.XHRHdls['getReferences'].execute();
    }

    public onReferencesRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                obj.editForm.setStatus(responseParsed.status);

                //get data
                obj.getModData();
            })
        }
    }

    public getModData() {

        this.loadingIn(this.editForm.builtTemplate);

        let url : string = '/api/mod/get/' + this.getVnAppZone().app.params.id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetModDataForEdit;
        this.XHRHdl.execute();
    }

    private onGetModDataForEdit(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.editForm.setModData(responseParsed.data);
            });
            obj.loadingOut(obj.editForm.builtTemplate);
        }
    }

    public cancelForm() {

        this.onClickCancelEdit();
    }

    public onClickCancelEdit(){

        this.releaseLock();
        page.redirect("/mods/");
    }

    protected save() {

        this.loadingIn(this.editForm.builtTemplate);

        let formReq_url: string = '/api/mod/save/';
        let formReq_params: Array<Array<string>> = [];

         let subViewModel = JSON.parse( ko.toJSON(this.editForm.getViewModelForRequest()));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    if (req.request.status === 200) {

                        obj.releaseLock();

                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Mod saved !");

                        page.redirect('/mods/');
                    }
                });
                obj.loadingOut(obj.editForm.builtTemplate);
            }
        });
        XHRHdl.execute();
    }

    public getSelectedModder() {

        return this.editForm.userFilter.getUserObject();
    }

    protected filterSimpleOnChange(idElement) {
       
        if(idElement == "filterModType"){
            
            this.editForm.updateSelectedModTypes();
        }

        //handle files
        this.validateFilesUploader();
    }

    protected validateFilesUploader() {
        
        let selectedModder = this.getSelectedModder();
        if(selectedModder){
            this.editForm.fileUploader.setEnabled(true);
        }else{
            this.editForm.fileUploader.setFiles([]);
            this.editForm.fileUploader.setEnabled(false);
        }
    }

    //get Ck editor data
    protected getDescriptionText(){

        return descriptionEditor.getData();
    }

    protected setDescriptionText(data){

        descriptionEditor.setData(data);
    }
    
    protected setInstructionsText(data){

        instructionsEditor.setData(data);
    }

    protected getInstructionsText(){

        return instructionsEditor.getData();
    }

    //user suggestion
    protected getUsersSuggestion(keyword, idElement) {
    
        if( "getUsersSuggestion" in this.XHRHdls ){
            this.XHRHdls["getUsersSuggestion"].cancelAndReset();
        }

        //for now only for FX
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        if(!idBrand){
            idBrand = "53"
        }

        let subViewModel = {list: {keyword: keyword, limit: 100}, idElement: idElement, idBrand: idBrand};
        let usrReq_url: string = '/api/search/website-users/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls['getUsersSuggestion'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getUsersSuggestion'].onReadyStateFunction = this.onGetUsersSuggestionsReturn;
        this.XHRHdls['getUsersSuggestion'].execute();
    }

    protected onGetUsersSuggestionsReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response || '{}');

                if (req.request.status == 200) {

                    if (responseParsed.data.users) {
                        obj.editForm.userFilter.setUsers(responseParsed.data.users);
                    }
                } else if (req.request.status == "423") {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                }

                // LOADING : ends
                obj.editForm.deactivateLoading();
            }
        }
    }

    //modetype suggestion
    protected onPromptInputChangeClear(idElement) {
        
    }

    protected onAutocompleteInputClick(idElement) {

    }

    protected onAutocompleteInputClear(idElement) {
       
    }

    protected onAutocompleteOptionChange(idElement) {

    }

    protected onAutocompleteAddNewInputChange(idElement : string) { 
       
    }

    protected onAutocompleteAddNewSelected(idElement) {

    }

    protected onAutocompleteAddNewInputClick(idElement) { // TODO: May be useless
   
    }

    //filter suggestion
    protected getSuggestions(keyword, idElement) {

        if(idElement == 'filterTagByType'){
           this.getTagByTypeSuggestions(keyword, idElement); 
        }
    }
    
    protected getTagsSuggestion(keyword, idElement) {

        if(idElement == 'filterModType'){
            this.getModTypeSuggestions(keyword, idElement);
        }
    }

    protected getTagByTypeSuggestions(keyword, idElement) {
        
        if( "getTagByTypeSuggestion" in this.XHRHdls ){
            this.XHRHdls["getTagByTypeSuggestion"].cancelAndReset();
        }

        //fX idType
        let tagTypesIds = [222, 1191]
        let usrReq_url: string = '/api/tags/get_by_types/';
        let subViewModel = {keyword: keyword, tagTypesIds: tagTypesIds, idElement: idElement }
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls['getTagByTypeSuggestion'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getTagByTypeSuggestion'].onReadyStateFunction = this.onGetTagByTypeSuggestionReturn;
        this.XHRHdls['getTagByTypeSuggestion'].execute();
    }

    protected onGetTagByTypeSuggestionReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {

                    if (responseParsed.data) {
                        obj.editForm.filterTagByType.setOptions(responseParsed.data);
                    }
                }
            }
        }
    }

    protected getModTypeSuggestions(keyword, idElement) {
        
        if( "getSuggestion" in this.XHRHdls ){
            this.XHRHdls["getModByTypeSuggestion"].cancelAndReset();
        }

        let subViewModel = {keyword: keyword, idElement: idElement};
        let usrReq_url: string = '/api/search/modetype/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls['getModByTypeSuggestion'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getModByTypeSuggestion'].onReadyStateFunction = this.onGetModTypeSuggestionReturn;
        this.XHRHdls['getModByTypeSuggestion'].execute();
    }

    protected onGetModTypeSuggestionReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {

                    if (responseParsed.data) {
                        obj.editForm.filterModType.setTags(responseParsed.data);
                    }
                }
            }
        }
    }

    // //file uploader
    protected intilizeFileUploaders() {
        
        this.editForm.fileUploader.initializeFileUploader();
    }

    //ck editor
    protected initializeCkEditors() {

        for(let name in CKEDITOR.instances)
        {
            CKEDITOR.instances[name].destroy(true);
        }

        if (!CKEDITOR.stylesSet.registered.my_styles) {
            CKEDITOR.stylesSet.add('my_styles', [
                // Block-level styles.
                {name: 'Heading 1', element: 'h1'},
                {name: 'Heading 2', element: 'h2'},
                {name: 'Heading 3', element: 'h3'},
                {name: 'Preformatted', element: 'pre'},
                // Inline styles.
                {name: 'Related: One link', element: 'span', attributes: {'class': 'related-single'}},
                {name: 'Next - One link', element: 'span', attributes: {'class': 'next-single'}},
                {name: 'Affiliate - One link', element: 'span', attributes: {'class': 'affiliate-single'}},
                {name: 'Spoiler Alert', element: 'span', attributes: {'class': 'article-alert'}},
                {name: 'Tip', element: 'div', attributes: {'class': 'emaki-custom tip'}},
                {name: 'Warning', element: 'div', attributes: {'class': 'emaki-custom warning'}},
                {name: 'Note', element: 'div', attributes: {'class': 'emaki-custom note'}},
                {name: 'Expandable', element: 'div', attributes: {'class': 'emaki-custom expandable'}},
                {name: 'Pullquote', element: 'div', attributes: {'class': 'emaki-custom pullquote'}},
                {name: 'Promoted', element: 'div', attributes: {'class': 'emaki-custom promoted'}},

            ]);
        }

        CKEDITOR.on('dialogDefinition', function (ev) {
            var dialogName = ev.data.name;
            var dialogDefinition = ev.data.definition;

            //Remove background color and border color in dialog cells properties
            if(dialogName == "cellProperties"){
                const cellProps = dialogDefinition.getContents('info');
                cellProps.remove("borderColor")
                cellProps.remove("bgColor")
            }

            //remove features from table dialog
            if (dialogName == 'table') {

                // Get the advanced tab reference
                var infoTab2 = dialogDefinition.getContents('advanced');

                //Set the default
                // Remove the 'Advanced' tab completely
                dialogDefinition.removeContents('advanced');

                // Get the properties tab reference
                var infoTab = dialogDefinition.getContents('info');

                // Remove unnecessary bits from this tab
                infoTab.remove('cmbAlign');
                infoTab.remove('txtWidth');
                infoTab.remove('txtHeight');
                infoTab.remove('txtCaption');
                infoTab.remove('txtSummary');
            }


            if (dialogName == 'link') {

                /* Getting the contents of the Target tab */

                var targetTab = dialogDefinition.getContents('target');
                var informationTab = dialogDefinition.getContents('info');
                var advancedTab = dialogDefinition.getContents('advanced');

                //remove the browse server button
                informationTab.remove('browse')

                //moving the target dropdown to the main tab
                var targetField = targetTab.get('linkTargetType');

                targetTab.remove('linkTargetType');
                informationTab.add(targetField);

            }
        });

        //description editor
        this.initCkEditor('descriptionText');
        descriptionEditor = CKEDITOR.instances.descriptionText;
        
        //instructions editor
        this.initCkEditor('instructionsText');
        instructionsEditor = CKEDITOR.instances.instructionsText;

        // Adds comments to specified editors
        this.addLinkToolCommand([descriptionEditor]);
        this.addImagePickerCommand([descriptionEditor]);
        this.addUpdateBlockCommand([descriptionEditor]);
    }

    protected initCkEditor(idElement) {

        CKEDITOR.replace(idElement, {
            height: '500px',
            toolbar: 'MA',
            fillEmptyBlocks: false,
            extraAllowedContent: 'img(*){*}[*];div(*){*}[*];pre(*){*}[*];code(*){*}[*];a[rel];a[target];a(*)',
            disallowedContent: 'p',
            removePlugins: 'elementspath,contextmenu,liststyle,tabletools,tableselection,image,forms',
            stylesSet: 'my_styles',
            format_tags: "p;h1;h2;h3",
            format_p: {
                element: 'p'
            }
        });


        CKEDITOR.config.toolbar_MA = [['Source', '-', 'Cut', 'Copy', 'Paste', '-', 'Undo', 'Redo', 'RemoveFormat', '-', 'Link', 'Unlink', '-', 'Table', 'HorizontalRule', 'SpecialChar', 'ImgBtn', 'Styles', 'InsertArticleBtn', 'TagBtn'], ['Bold', 'Italic', 'Strike', 'NumberedList', 'BulletedList', '-', 'Blockquote', 'LinkBtn', 'Maximize']];

        CKEDITOR.config.enterMode = CKEDITOR.ENTER_BR;

        CKEDITOR.config.contentsCss = [CKEDITOR.getUrl('contents.css'), '/css/cke_style.css?v=2.5'];

        CKEDITOR.config.skin = "emakiCustomComprehensive";
        CKEDITOR.config.extraPlugins = "wordcount,notification";

        CKEDITOR.config.forcePasteAsPlainText = true;
        descriptionEditor = CKEDITOR.instances.descriptionText;
        instructionsEditor = CKEDITOR.instances.instructionsText;

        CKEDITOR.config.wordcount = {
            // Whether or not you want to show the Paragraphs Count
            showParagraphs: false,

            // Whether or not you want to show the Word Count
            showWordCount: true,

            // Whether or not you want to show the Char Count
            showCharCount: true
        }
        CKEDITOR.config.allowedContent = true;
    }

    protected addLinkToolCommand(editors) {

        editors.forEach(function (editor) {

            function showLinkTool(obj) {

                return {
                    exec: function (editor) {
                        obj.showLinkTool();
                    }
                };

            }

            editor.addCommand("linkToolCommand", showLinkTool(this));

            editor.ui.addButton('LinkBtn', { // add new button and bind our command
                label: "Link Tool",
                command: 'linkToolCommand',
                toolbar: 'insert',
            });
        })
    }

    protected showLinkTool() {

        let url = "https://datastudio.google.com/u/0/reporting/1JtF204Vz8MIa9DhToLzu4Ou2bIqTSuVt/page/4uYeB";
        //launch the link tool in new tab
        var element = document.createElement('a');
        element.setAttribute('href', url);
        element.setAttribute('target', '_blank');
        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }

    protected addUpdateBlockCommand(editors) {
        let _myThis = this;

        editors.forEach(function (editor) {

            function addUpdateBlock(obj) {

                return {
                    exec: function (editor) {
                        _myThis.addUpdateBlock(editor);
                    }
                };
            }

            editor.addCommand("updateBlockCommand", addUpdateBlock(this));

            editor.ui.addButton('UpdateBtn', { // add new button and bind our command
                label: "Update",
                command: 'updateBlockCommand',
                toolbar: 'insert',

            });
        });
    }

    protected addUpdateBlock(editor) {
        let d = new Date();
        let dformat = [d.getFullYear(), ('0' + (d.getMonth() + 1)).slice(-2), ('0' + d.getDate()).slice(-2)].join('/') + ' ' + [('0' + d.getHours()).slice(-2), ('0' + d.getMinutes()).slice(-2)].join(':') + " EST";
        let authorName = this.getVnAppZone().app.loggedUser.user.valnet_user.fullName;
        let tag = '<div class="emaki-custom update"><h3>UPDATE: ' + dformat + ' BY ' + authorName.toUpperCase() + '</h3><strong><em>Title Here..</em></strong><br><br>Text Here..</div>'

        var tagElement = CKEDITOR.dom.element.createFromHtml(tag, editor.document);
        editor.insertElement(tagElement);
    }

    protected addImagePickerCommand(editors) {
        let _myThis = this;

        editors.forEach(function (editor) {

            function showMyDialog(obj) {

                return {
                    exec: function (editor) {
                        _myThis.showImagePicker("single-select", editor);
                    }
                };
            }

            editor.addCommand("imagePickerCommand", showMyDialog(this));

            editor.ui.addButton('ImgBtn', { // add new button and bind our command
                label: "Insert Images",
                command: 'imagePickerCommand',
                toolbar: 'insert',
                icon: '/node_modules/ckeditor4/plugins/image2/icons/image.png'
            });
        })
    }

    protected showImagePicker(mode, target) {

        if (typeof target.name !== 'undefined' && target.name !== null){
            target = target.name // @TODO revisit
        }

        this.editForm.showImagePicker(mode, target);

    }

    // image picker functions
    protected getImageData(keyword = null) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.editForm.imagePicker.showLoading();

        let formReq_url: string = '/api/images/get/';
        let formReq_params: Array<Array<string>> = [];

        let viewModel = this.editForm.imagePicker.getViewModelForRequest();
        formReq_params.push(["data", ko.toJSON(viewModel)]);

        this.XHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.XHRHdl.onReadyStateFunction = this.onGetImageDataReturn;
        this.XHRHdl.execute();
    }

    protected onGetImageDataReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.updateImagePickerForm(responseParsed);
                obj.editForm.imagePicker.hideLoading();
                if(obj.editForm.imagePicker.getSelectedTab() == 'images' || obj.isSaveImage) {
                    obj.isSaveImage = false;
                }
            })
        }
    }

     protected updateImagePickerForm(responseParsed) {
        let selectedImages = this.editForm.imagePicker.getSelectedImages();

        if (responseParsed.paginatedImages && responseParsed.paginatedImages.data) {
            for (let image of responseParsed.paginatedImages.data) {
                image.selected = false;
                let imageSelected = selectedImages.find(i => i.id == image.id);
                if (imageSelected) {
                    image.selected = true;
                }
                image.fileSize = this.bytesToSize(image.fileSize);
            }
            this.editForm.imagePicker.setImagesPagination(responseParsed.paginatedImages);
            this.editForm.imagePicker.setImageResults(responseParsed.paginatedImages.data);
        }
    }

    protected bytesToSize(bytes) {
        var sizes = ['KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return 'n/a';
        var i = parseInt(String(Math.floor(Math.log(bytes) / Math.log(1024))));
        if (i == 0) return bytes + ' ' + sizes[i];
        return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
    }

    protected insertImage(image, target, extra_option) {

        if (target == "primary_image") {
            this.editForm.imageWidgetForPrimaryImage.setImage(image);
            this.editForm.updateImages(image, true, false);
        }else if (target == "other_images") {
            this.editForm.updateImages(image, false, false);
        }else if (target == "descriptionText") {
           
            let imgTag = this.buildImageTag(image, false, extra_option);

            if (typeof descriptionEditor !== 'undefined' && descriptionEditor !== null && typeof descriptionEditor.insertHtml === 'function') {
                this.insertTag(imgTag, descriptionEditor);
            }
        }
    }

    protected buildImageTag(image, addCaption, extra_option): string {

        let imgTag = '<img ';

        imgTag += 'src="' + image.url + '" ';
        if (image.altText != null) {
            imgTag += 'alt="' + image.altText + '" ';
        } else {
            imgTag += 'alt="" ';
        }
        imgTag += ' width=' + image.width + ' height=' + image.height + ' />';

        //add caption
        if (addCaption && image.caption != null && image.caption.trim() != "") {
            imgTag = '[caption]' + imgTag + ' ' + image.caption + '[/caption]';
        }

        return imgTag;
    }

    protected insertTag(tag, editor) {

        editor.insertHtml(tag);
    }

    protected removeImage(target) {

        if (target == "primary_image"){
            this.editForm.imageWidgetForPrimaryImage.clearImage();
            this.editForm.getTemplateViewModel().primaryImage(null);
        }
    }

    protected saveImages(images, insert, param, insertType='image') {
    
            let formReq_url: string = '/api/images/save/';
            let formReq_params: Array<Array<string>> = [];
    
            formReq_params.push(["data", ko.toJSON(images)]);
    
            let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
            XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    
            XHRHdl.onReadyStateFunction = (function (req, obj) {
    
                return function () {
    
                    obj.manageResponse(req, obj, function () {
    
                        let response = JSON.parse(req.request.response);
                        obj.editForm.setImagePickerTarget(null);
                        obj.editForm.imagePicker.onImageSaveReturn(response.images, insert, param, insertType);
    
                        obj.getImageData();
                    })
    
                }
            });
            XHRHdl.execute();
    }

    // request a lock
    protected releaseLock() {

        // request a lock release
        let usrReq_url: string = '/api/mod/release/' + this.getVnAppZone().app.params.id;
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.execute();
    }

    protected seeContent(data, event) {
        let modal = document.getElementsByClassName('generic-modal');
        let content = document.getElementById('file-item-' + data);
        if(modal.length > 0) {
            modal[0].classList.contains('is-showing') ? modal[0].classList.remove('is-showing') : modal[0].classList.add('is-showing');
        }
        if(content != null && content != undefined) {
            content.classList.contains('is-showing') ? content.classList.remove('is-showing') : content.classList.add('is-showing');
        }else{
            let contentModal = document.getElementsByClassName('content-modal');
            for (let i = 0; i < contentModal.length; i++) {
                contentModal[i].classList.remove('is-showing');
            }

        }
    }
}


// WEBPACK FOOTER //
// ./js/modules/mod_edit.ts